export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M17 8.5v-2c0-2.76-2.24-5-5-5s-5 2.24-5 5v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-10c0-1.1-.9-2-2-2zm-7 7c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2m-1.1-7v-2c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2z\"/>"
};